import React, { useEffect, useState } from "react";
import FileUpload from "assets/img/fileUpload.png";
import HubspotLogo from "assets/images/thirdparty app/hubspot.png";
import ActiveCampLogo from "assets/images/thirdparty app/activeCampaignLogo.png";
import ZohoLogo from "assets/images/thirdparty app/zoho.png";
import GoHighLevel from "assets/images/thirdparty app/goHighLevelLight.png";
import { guniLogoUrl } from "constant/constant";

const BrandProgressiveBar = ({ className, method }) => {
  className = "vh-center gap-2 " + className;

  const [width, setWidth] = useState(90);
  const [brand, setBrand] = useState(FileUpload);
  console.log(method);
  useEffect(() => {
    switch (method) {
      case "hubspot":
        setWidth(40);
        setBrand(HubspotLogo);
        break;
      case "zoho":
        setWidth(95);
        setBrand(ZohoLogo);
        break;
      case "ac":
        setWidth(65);
        setBrand(ActiveCampLogo);
        break;
      case "gohl":
        setWidth(100);
        setBrand(GoHighLevel);
        break;
      default:
        setWidth(50);
        setBrand(FileUpload);
        break;
    }
  }, [method]);

  return (
    <div className={className}>
      <img alt="logo" src={brand} width={width} className="img-fit" />
      <span className="progressLine">
        <span className="progressPoint"></span>
      </span>
      <img width={100} src={guniLogoUrl} alt="guni logo" className="ms-1 img-fit" />
    </div>
  );
};

export default BrandProgressiveBar;
